import { call, put, takeEvery, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { isEqual } from 'lodash';
import { ApisauceInstance } from 'apisauce';

import { ParseHtmlMessage } from '../../components/common';
import { ON_SPONSOR_GIFT } from './payment.redux';
import Api from '../../services/api-caller';
import {
  formattedPaymentError,
  GARevenueTracking,
  toastError,
} from '../../utils';
import { ROUTES, TEXT_CONSTANTS } from '../../constants';
import { ON_CLEAR_BASKET, ON_GET_CHILDREN } from '../children';
const getAttributionData = (state) => state.attribution;

// @ts-ignore
export function* onSponsorGiftRequest(api, { payload }) {
  let submissionId;
  let gaReportedDonationAmount;
  let googleAnalyticsPaymentItems;
  let attributionData: ReturnType<typeof getAttributionData>;
  try {
    const { payload: api_payload, googleAnanlyticsPurchaseEventPayload } =
      payload;
    attributionData = yield select(getAttributionData);
    gaReportedDonationAmount =
      googleAnanlyticsPurchaseEventPayload.gaReportedDonationAmount;
    googleAnalyticsPaymentItems =
      googleAnanlyticsPurchaseEventPayload.googleAnalyticsPaymentItems;

    const apiPayload = { ...api_payload, attribution: attributionData };

    const { res = {} } = yield call(Api.callServer, api, apiPayload);
    const { message = '', submission_id } = res || {};
    submissionId = submission_id;
    yield put(ON_SPONSOR_GIFT.success({ mail: api_payload.mail, message }));
    yield put(push(ROUTES.EXIT.path));
    yield put(ON_CLEAR_BASKET());
    yield put(ON_GET_CHILDREN());
  } catch (err: any) {
    let message = err.message;
    const data = err.data;
    let isPaymentError = false;
    if (
      data.error_key &&
      isEqual(data.error_key, TEXT_CONSTANTS.PAYMENT_ERROR_KEY)
    ) {
      toastError(TEXT_CONSTANTS.PAYMENT_ERROR_MSG); // If the payment is successful, but an exception occurs after,
      yield put(push(ROUTES.EXIT.path)); // we still want to navigate to the Exit screen.
    } else {
      isPaymentError = true;
      // @ts-ignore
      if (message == TEXT_CONSTANTS.DEFAULT_API_ERROR) {
        message = TEXT_CONSTANTS.PAYMENT_PROCESSS_ERROR_MSG;
      }
      toastError(formattedPaymentError(message));
    }
    yield put(ON_SPONSOR_GIFT.failure(isPaymentError));
  } finally {
    GARevenueTracking(
      gaReportedDonationAmount,
      submissionId,
      googleAnalyticsPaymentItems,
      attributionData
    );
    yield put(ON_SPONSOR_GIFT.fulfill());
  }
}

export default (api: ApisauceInstance) => {
  const onSponsorGiftRequestApi = (data: any) => api.post('/Sponsors', data);

  return [
    takeEvery(
      // @ts-ignore
      ON_SPONSOR_GIFT.TRIGGER,
      onSponsorGiftRequest,
      onSponsorGiftRequestApi
    ),
  ];
};
